import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PublicShell from "@/components/public/PublicShell";
import { ArrowRight, Home, MessageCircle, Tag } from "lucide-react";

export default function NotFound() {
    const { user } = useAuth();
    return (
        <PublicShell>
            <div
                data-testid="not-found-page"
                style={{ maxWidth: 720, margin: "80px auto 96px", padding: "0 28px", textAlign: "center" }}
            >
                <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.24em", color: "#C6A86B", textTransform: "uppercase" }}>
                    404 · Not found
                </div>
                <h1 style={{ marginTop: 14, fontSize: 40, fontWeight: 800, letterSpacing: "-0.02em" }}>
                    That page isn&apos;t here.
                </h1>
                <p style={{ marginTop: 14, color: "var(--muted-foreground, #57534E)", fontSize: 16, lineHeight: 1.55 }}>
                    The link may be broken, expired, or the page may have moved. Try one of these instead.
                </p>
                <div style={{ marginTop: 32, display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 12 }}>
                    <Link to="/" data-testid="nf-home"
                        className="inline-flex items-center gap-2 rounded-full bg-stone-900 text-stone-50 px-5 py-2.5 text-sm font-semibold hover:bg-stone-800">
                        <Home size={14} /> Return to Homepage
                    </Link>
                    {user?.id && (
                        <Link to="/dashboard" data-testid="nf-dashboard"
                            className="inline-flex items-center gap-2 rounded-full bg-[#C6A86B] text-[#0B1122] px-5 py-2.5 text-sm font-semibold hover:opacity-90">
                            Open Dashboard <ArrowRight size={14} />
                        </Link>
                    )}
                    <Link to="/pricing" data-testid="nf-pricing"
                        className="inline-flex items-center gap-2 rounded-full border border-stone-300 px-5 py-2.5 text-sm font-semibold hover:bg-stone-100">
                        <Tag size={14} /> View Pricing
                    </Link>
                    <Link to="/support" data-testid="nf-support"
                        className="inline-flex items-center gap-2 rounded-full border border-stone-300 px-5 py-2.5 text-sm font-semibold hover:bg-stone-100">
                        <MessageCircle size={14} /> Contact Support
                    </Link>
                </div>
            </div>
        </PublicShell>
    );
}
